<template>
  <!-- Bạn có thể truyền prop type="primary | success | warning | error" -->
  <span class="badge-new" :class="`badge-${type}`">
    <slot>NEW</slot>
  </span>
</template>

<script>
export default {
  name: "BadgeNew",
  props: {
    type: {
      type: String,
      default: "error", // Mặc định là màu đỏ
      validator: (value) => ["primary", "success", "warning", "error"].includes(value),
    },
  },
};
</script>

<style scoped>
/* 1. Base Styles */
.badge-new {
  font-size: 10px;
  font-weight: 800;
  padding: 3px 7px;
  border-radius: 10px;
  text-transform: uppercase;
  color: white;
  line-height: 1;
  display: inline-block;

  /* Sử dụng biến RGB để có thể chỉnh độ trong suốt (opacity) cho animation */
  background: rgb(var(--badge-rgb));

  /* Animation */
  animation: wiggle-pulse 2s ease-in-out infinite;
  transform-origin: center center;
}

/* 2. Color Variants (Cấu hình màu tại đây) */
.badge-primary {
  --badge-rgb: 52, 152, 219; /* Blue #3498db */
}
.badge-success {
  --badge-rgb: 46, 204, 113; /* Green #2ecc71 */
}
.badge-warning {
  --badge-rgb: 241, 196, 15; /* Yellow #f1c40f */
}
.badge-error {
  --badge-rgb: 255, 82, 82;  /* Red #ff5252 */
}

/* 3. Keyframes (Dùng chung cho tất cả các màu) */
@keyframes wiggle-pulse {
  0% {
    transform: rotateZ(0) scale(1);
    box-shadow: 0 0 0 0 rgba(var(--badge-rgb), 0.7);
  }

  10% {
    transform: rotateZ(-20deg) scale(1.2);
  }

  15% {
    transform: rotateZ(15deg) scale(1.2);
  }

  20% {
    transform: rotateZ(-15deg) scale(1.2);
    /* Shadow lan ra và dùng chính màu của badge */
    box-shadow: 0 0 0 10px rgba(var(--badge-rgb), 0);
  }

  25% {
    transform: rotateZ(10deg) scale(1.2);
  }

  30% {
    transform: rotateZ(-5deg) scale(1.1);
  }

  35% {
    transform: rotateZ(0) scale(1);
    box-shadow: 0 0 0 0 rgba(var(--badge-rgb), 0);
  }

  100% {
    transform: rotateZ(0) scale(1);
    box-shadow: 0 0 0 0 rgba(var(--badge-rgb), 0);
  }
}
</style>
